import { makeStyles } from '@material-ui/core/styles';
import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  header: {
    display: 'flex',
    flexDirection: 'column'
  },
  headerRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: 8,
    margin: theme.spacing(0.5)
  },
  card: {
    background: theme.colorPalette.beige_25,
    // Reskin: section bodies are white inside the outlined card; nested items stay beige insets.
    ...reskinStyles(theme, { background: theme.colors.card_background_primary_editable }),
    width: '100%',
    margin: 0,
    padding: theme.spacing(6, 8)
  },
  centerCheckbox: {
    marginTop: theme.spacing(3)
  },
  divider: {
    width: 1,
    height: 24,
    backgroundColor: theme.colorPalette.beige_60
  },
  container: {
    borderRadius: theme.sizes.roundCorners,
    border: `2px solid ${theme.colorPalette.white}`,
    backgroundColor: theme.colors.panel_background,
    padding: '18px 32px 24px 32px',
    marginBottom: theme.spacing(2)
  },
  button: {
    width: 163
  },
  rightContainer: {
    display: 'flex',
    gap: theme.spacing(2)
  },
  rightLabel: {
    color: theme.colorPalette.beige_75,
    display: 'inline',
    textTransform: 'uppercase'
  },
  notification: {
    backgroundColor: `${theme.colorPalette.beige_40} !important`,
    boxShadow: 'none !important',
    padding: theme.spacing(4),
    margin: 0,
    minHeight: 'unset',
    display: 'flex',
    alignItems: 'center'
  },
  editIcon: {
    width: 24,
    height: 24
  },
  editButton: {
    padding: 0
  }
});

export default makeStyles(styles);
